import React from "react";

import {spacing24} from "@churchofjesuschrist/eden-style-constants"
import styled from "styled-components";

import LoadingSpinner from "../loading-spinner/loading-spinner";

const Container = styled.div`
width:400px;
margin: ${spacing24} auto;
`;


const ContentLoadingSpinner = ({message}) => (<Container>
  <LoadingSpinner large={true} message={message}/>
</Container>);

export default ContentLoadingSpinner;